import background from './Images/mg_background.jpg'
import poster from './Images/mg_landing.jpg'

var info = {
  title: 'MatrixGold | Request Demo',
  video: 'https://gemvision.com/sharedMedia/GV1363-MatrixGold-3-Overview-V2.mp4',
  poster: poster,
  background: background,
  logo: 'https://gemvision.com/Images/MatrixGold/MatrixGold%20Light%20Registered.svg',
  moto: 'Smart, Powerful, and Flexible CAD for Jewelry Design',
  description1:
    'Register to watch on-demand software demonstration videos and speak with a Gemvision representative about how MatrixGold can transform and grow your custom business.',
  description2: 'No commitment is required.',
  buttonColor: '#b4975a',
  titleBackgroundColor: '#282723'
}

export default info
